import React, { Component } from "react";
import commonUtil from "../../../../../../../utils/commonUtil";

class OrderDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  selectedProduct = this.props.selectedProduct;

  render() {
    const { isWap, lables, isComprasModal, isRegalosModal } = this.props;

    const hideDataForCertainStatus =
      this.props.compareEventStatus(
        this.selectedProduct.deliveryStatus,
        "cancel.delivery.message"
      ) ||
      this.props.compareEventStatus(
        this.selectedProduct.deliveryStatus,
        "return.delivery.message"
      ) ||
      this.props.compareEventStatus(
        this.selectedProduct.deliveryStatus,
        "return.reinvested.delivery.message"
      );

    const storeDelivery = this.props.compareEventStatus(
      this.selectedProduct.deliveryStatus,
      "store.delivery.message"
    );

    const dateOfPurchase = isComprasModal
      ? this.selectedProduct?.purchaseInfo?.dateofPurchase || ""
      : this.selectedProduct &&
        this.selectedProduct.guestInfo &&
        this.selectedProduct.guestInfo.dateofPurchase
      ? this.selectedProduct.guestInfo.dateofPurchase
      : "";

    let deliveryAddress = isComprasModal
      ? this.selectedProduct &&
        this.selectedProduct.purchaseInfo &&
        this.selectedProduct.modeofDelivery === "physical" &&
        this.selectedProduct.purchaseInfo.deliveryAddress
        ? this.selectedProduct.purchaseInfo.deliveryAddress
        : ""
      : this.selectedProduct &&
        this.selectedProduct.guestInfo &&
        this.selectedProduct.modeofDelivery === "physical" &&
        this.selectedProduct.guestInfo.popupDelivery
      ? this.selectedProduct.guestInfo.popupDelivery
      : "";

    if (hideDataForCertainStatus) {
      deliveryAddress = null;
    }

    if(storeDelivery && isComprasModal) {
      deliveryAddress = null;
    }

    let invitedName =
      this.selectedProduct &&
      this.selectedProduct?.guestInfo &&
      this.selectedProduct.guestInfo.name
        ? this.selectedProduct.guestInfo.name
        : commonUtil.getLabel(lables.EventAdminPage, "adminpage.regalosrecibidos.guest.name") || "";

    if (isComprasModal && hideDataForCertainStatus) {
      invitedName = null;
    }

    let wareHouseName = isComprasModal
      ? this.selectedProduct?.purchaseInfo?.warehouseInfo || ""
      : this.selectedProduct &&
        this.selectedProduct.guestInfo &&
        this.selectedProduct.guestInfo.popupStore
      ? this.selectedProduct.guestInfo.popupStore
      : "";

    if (isComprasModal && hideDataForCertainStatus) {
      wareHouseName = null;
    }

    if(storeDelivery && isRegalosModal){
      deliveryAddress = null;
    }

    const orderNumber = this.selectedProduct.pedidoNo;

    return (
      <div
        className={`order-details-wrapper${
          isComprasModal && isWap ? " order-details-wrapper-bottom" : ""
        }`}
      >
        {
          orderNumber && 
          <div className="order-details-info-row">
            <div className="order-details-sub-label">
              {commonUtil.getLabel(
                lables.EventAdminPage,
                "adminpage.regalosrecibidos.trackorder.orderno.label"
              )}
              :
            </div>
            <div className="order-details-sub-value">{orderNumber}</div>
          </div>
        }
        
        <div className="order-details-date-row">
          <div className="order-details-label-group">
            <div className="order-details-label">
              {commonUtil.getLabel(
                lables.EventAdminPage,
                "adminpage.regalosrecibidos.date.label"
              )}
              :
            </div>
            <div className="order-details-date-value">{dateOfPurchase}</div>
          </div>
        </div>

        {wareHouseName != null && ((storeDelivery && isComprasModal) || (storeDelivery && isRegalosModal)) && (
          <div className="order-details-info-row">
            <div className="order-details-sub-label">
              {commonUtil.getLabel(
                lables.EventAdminPage,
                "adminpage.regalosrecibidos.warehouse.label"
              )}
              :
            </div>
            <div className="order-details-sub-value">{wareHouseName}</div>
          </div>
        )}

        {deliveryAddress != null && this.selectedProduct.modeofDelivery === "physical" && (
          <div className="order-details-info-row">
            <div className="order-details-sub-label">
              {commonUtil.getLabel(
                lables.EventAdminPage,
                "adminpage.regalosrecibidos.delivery.address.label"
              )}
              :
            </div>
            <div className="order-details-sub-value">{deliveryAddress}</div>
          </div>
        )}

        {invitedName != null && !isComprasModal && (
          <div className="order-details-info-row">
            <div className="order-details-sub-label">
              {commonUtil.getLabel(
                lables.EventAdminPage,
                "adminpage.regalosrecibidos.delivery.address.invited.label"
              )}
              :
            </div>
            <div className="order-details-sub-value">{invitedName}</div>
          </div>
        )}

      </div>
    );
  }
}

export default OrderDetails;
